const employeeData = employee => {
  const newEmployee = { ...employee };
  delete newEmployee.proportionalVacationDays;
  delete newEmployee.legalVacationDays;
  delete newEmployee.aditionalVacationDays;
  delete newEmployee.progressiveVacationDays;
  return {
    ...newEmployee
  };
};

export const clearSettlements = values => {
  return values.settlementGroup.employees.map(employee => {
    return {
      ...employee,
      destroy: true
    };
  });
};

const prepareSettlementGroupToSave = (values, companyId) => {
  const prepareBalanceAttributes = (_settlementBalanceId, balanceId) => {
    if (_settlementBalanceId) {
      return _settlementBalanceId;
    }
    const settlementBalanceId = values.settlementGroup.balanceSettlementPairs.find(
      balance => balance.balanceId === balanceId
    );
    return settlementBalanceId ? settlementBalanceId.settlementBalanceId : null;
  };

  const getEmptyBalances = () => {
    return (
      values.balanceSettlementPairs
        .filter(balance => !values.settlementGroup.balanceIds.includes(balance.balanceId))
        .map(balance => {
          return {
            id: balance.settlementBalanceId,
            _destroy: 'true'
          };
        }) || []
    );
  };

  const settlementsAttributes = values.settlementGroup.employees.map(employee => {
    return {
      id: employee.settlementId || null,
      employee: employeeData(employee),
      proportionalVacationDays: employee.proportionalVacationDays,
      legalVacationDays: employee.legalVacationDays,
      aditionalVacationDays: employee.aditionalVacationDays,
      progressiveVacationDays: employee.progressiveVacationDays,
      inGroup: true,
      _destroy: employee.destroy ? 'true' : 'false',
      settlementBalancesAttributes: [
        ...(employee?.balances?.map(balance => {
          return {
            id: prepareBalanceAttributes(balance.settlementBalanceId, balance?.balance?.id),
            balance: { ...balance.balance },
            settlementBase: balance.settlementBase,
            amount: balance.amount,
            _destroy: values.settlementGroup?.balanceIds.includes(balance?.balance?.id) ? 'false' : 'true'
          };
        }) || []),
        ...getEmptyBalances()
      ]
    };
  });

  const settlementToDestroy = values.employeesToDestroy
    .map(employee => {
      return {
        id: employee.settlementId,
        _destroy: 'true'
      };
    })
    .filter(employee => employee.id);

  settlementsAttributes.push(...settlementToDestroy);

  return {
    settlementGroup: {
      ...values.settlementGroup,
      terminationReason: values.terminationReasonObject || values.terminationReason,
      companyId,
      settlementsAttributes
    }
  };
};

export default prepareSettlementGroupToSave;
